/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PreviewEquipmentBrowserViewRequest = {
  agentId: string;
  /**
   * Request body for preview_equipment_browser_view.
   */
  body: components.PreviewEquipmentBrowserViewRequestBody;
};

/** @internal */
export const PreviewEquipmentBrowserViewRequest$inboundSchema: z.ZodType<
  PreviewEquipmentBrowserViewRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
  body: components.PreviewEquipmentBrowserViewRequestBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type PreviewEquipmentBrowserViewRequest$Outbound = {
  agent_id: string;
  body: components.PreviewEquipmentBrowserViewRequestBody$Outbound;
};

/** @internal */
export const PreviewEquipmentBrowserViewRequest$outboundSchema: z.ZodType<
  PreviewEquipmentBrowserViewRequest$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentBrowserViewRequest
> = z.object({
  agentId: z.string(),
  body: components.PreviewEquipmentBrowserViewRequestBody$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function previewEquipmentBrowserViewRequestToJSON(
  previewEquipmentBrowserViewRequest: PreviewEquipmentBrowserViewRequest,
): string {
  return JSON.stringify(
    PreviewEquipmentBrowserViewRequest$outboundSchema.parse(
      previewEquipmentBrowserViewRequest,
    ),
  );
}
export function previewEquipmentBrowserViewRequestFromJSON(
  jsonString: string,
): SafeParseResult<PreviewEquipmentBrowserViewRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      PreviewEquipmentBrowserViewRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreviewEquipmentBrowserViewRequest' from JSON`,
  );
}
